const columns = {
  select: { id: "select", name: "", sortable: false, deselectable: false },
  group: { id: "group", name: "Group", sortable: true, deselectable: false },
  hasSBAccount: { id: "hasSBAccount", name: "Account", sortable: false, deselectable: false, align: "text-center" },
  lesson: { id: "lesson", name: "Lesson", sortable: true, deselectable: false },
  subject: { id: "subject", name: "Subject", sortable: true, deselectable: false },
  location: { id: "location", name: "Location", sortable: true, deselectable: true },
  studentCounts: { id: "studentCount", name: "Students", sortable: false, deselectable: true, align: "text-end" },
  bookingCounts: { id: "bookingCount", name: "Bookings", sortable: false, deselectable: true, align: "text-end" },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false, align: "text-end" },
}

const defaultColumns = [
  "select",
  "group",
  "hasSBAccount",
  "lesson",
  "subject",
  "location",
  "studentCounts",
  "bookingCounts",
  "actions",
]

const downloadOptions = [{ key: "xls", name: "Download All XLS" }]

const filters = {
  has_bookings: { id: "has_bookings", name: "Has Bookings" },
  no_bookings: { id: "no_bookings", name: "No Bookings" },
  has_account: { id: "has_account", name: "Has SB Account" },
  no_account: { id: "no_account", name: "No SB Account" },
  student_mismatch: { id: "student_mismatch", name: "Student Mismatch" },
  unassigned: { id: "unassigned", name: "Unassigned" },
}

export { columns, defaultColumns, downloadOptions, filters }
